import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";

const centerVertically = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
};

export default function Email() {
  const [email, setEmail] = useState(''); // Estado para armazenar o valor do email
  const { post } = useFetch();
  const navigate = useNavigate();

  async function enviarEmail() {
    try {
      if (email === '') {
          Swal.fire({
            title: "O espaço do email está vazio",
            text: "Erro ao enviar email ",
            icon: "error",
        })
      } else {
        const body = {
          email: email, // Adicione o email ao corpo do objeto
        };
        let response = await post("/recuperarsenha", body);
          if(response.status === 404) {
              Swal.fire({
                title: "Não tem nenhum usuário cadastrado com este email",
                text: "Erro ao enviar email ",
                icon: "error",
            })
          }
          else if (response.status === 200) {
              navigate("/login");
              Swal.fire({
                title: "Email enviado com sucesso",
                text: "Email enviado com sucesso ",
                icon: "success",
            })
          }
        }
      }
     catch (error) {
      console.error("Erro no enviarEmail():", error);
    }
  }

  return (
    <div className="image-background full">
      <div style={centerVertically}>
        <div className="col-md-3 email-block">
          <h2 className="text-center mb-4">Informe seu email</h2>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                name="email"
                placeholder="Email"
                value={email}
                className="input-login"
                onChange={(e) => setEmail(e.target.value)} // Atualiza o estado quando o campo de email muda
                required
              />
            </Form.Group>
            <div className="col text-center mb-3">
              <Button className="btn-padrao btn-lg btn-login px-5" id="btnLogin" onClick={enviarEmail}>Enviar</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

